export default "__VITE_PUBLIC_ASSET__75090109__"